export default "__VITE_ASSET__5e4d7ae5__"